<template>
  <div>
    <v-card color="grey lighten-5 ma-0 pa-0" :loading="loading">
      <document-action-header :title="$t('Versions')" @on-close-click="onCloseClick" />

      <v-card-text class="overflow-y-auto" style="max-height: 250px;">
        <template v-for="version in versionList">
          <version-item
            :version="version"
            v-bind:key="version.documentId"
            @on-click="onVersionClick"
          />
        </template>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import DocumentActionHeader from "@/components/search/results/list/item/actions/DocumentActionHeader";
import VersionItem from "@/components/search/results/list/item/actions/version/VersionItem";
import DocumentService from "@/services/DocumentService";
import Version from "@/ecm/models/search/results/list/Version";

export default {
  name: "VersionList",
  components: {
    DocumentActionHeader,
    VersionItem
  },
  props: {
    documentId: {
      type: Number,
      required: true
    }
  },
  created() {
    this.loadData();
  },
  data() {
    return {
      versionList: [],
      loading: false
    };
  },
  methods: {
    onCloseClick() {
      this.$emit("on-close-click");
    },
    onVersionClick(documentId) {
      this.$emit("on-version-click", documentId);
    },
    loadData() {
      this.loading = true;
      DocumentService.getVersionList(this.documentId).then(data => {
        this.versionList = data.map(function(dto) {
          return new Version(dto);
        });
        this.loading = false;
      });
    }
  }
};
</script>